import { useContext } from 'react';
import { RuntimeContext } from '../../../common/RuntimeContext';
import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

/**
 *
 * @param {Object} params
 * @returns {function(*): *}
 */
export const getAssetReviewItem = (params) => {
    const { assetReviewItemId, pathsContext } = params;

    return (dispatch) =>
        VerbFetch(`${pathsContext.adminServerUrl}/assetreviewitems/${assetReviewItemId}`).then((body) => {
            dispatch({
                type: ACTIONS.GET_ASSET_REVIEW_ITEM,
                payload: {
                    assetReviewItem: body
                }
            });
        });
};

/**
 *
 * @param {Object} params
 * @returns {function(*): *}
 * @private
 */
export const getManyAssetReviewItems = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/assetreviewitems`;
    const url = buildQueryString(rest, baseUrl);
    return (dispatch) =>
        VerbFetch(url)
            .then((body) => {
                dispatch({
                    type: ACTIONS.GET_MANY_ASSET_REVIEW_ITEMS,
                    payload: {
                        assetReviewItems: body
                    }
                });
                return body;
            })
            .catch(console.error);
};

/**
 *
 * @param {Object} params
 * @returns {function(*): *}
 */
export const postAssetReviewItem = (params) => {
    const { body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/assetreviewitems`;
    const fetchOptions = {
        method: 'POST',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_ASSET_REVIEW_ITEM_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.POST_ASSET_REVIEW_ITEM_SUCCESS,
                    payload: {
                        assetReviewItem: response
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};

/**
 *
 * @param {Object} params
 * @returns {function(*): *}
 */
export const putAssetReviewItem = (params) => {
    const { assetReviewItemId, body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/assetreviewitems/${assetReviewItemId}`;
    const fetchOptions = {
        method: 'PUT',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_ASSET_REVIEW_ITEM_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.PUT_ASSET_REVIEW_ITEM_SUCCESS,
                    payload: {
                        assetReviewItem: response
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};

/**
 *
 * @param {Object} params
 * @returns {function(*): *}
 */
export const putManyAssetReviewItems = (params) => {
    const { sectionItemId, body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/assetreviewitems/sectionitem/${sectionItemId}`;
    const fetchOptions = {
        method: 'PUT',
        body
    };
    return (dispatch) =>
        VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.PUT_MANY_ASSET_REVIEW_ITEM_SUCCESS,
                    payload: {
                        assetReviewItems: response
                    }
                });
                return response;
            })
            .catch((err) => err);
};
